<template>
  <div v-if="apps.length" class="list-item-content">
    <img class="list-item-content-icon"
         src="@/assets/images/facebook_instagram.svg" />

    <div class="list-item-content-title">
      Facebook & Instagram
    </div>

    <base-btn-group :state="state"
                    :button-protect="supportsProtection"
                    button-allow
                    button-block
                    @click="changeAction" />
  </div>
</template>

<script>
  export default {
    props: {
      childId: {
        type: String,
        required: false
      }
    },

    data: () => ({
      state: null
    }),

    created() {
      this.state = this.action
    },

    computed: {
      ...mapGetters('children', {
        getFacebookAndInstagram: 'getFacebookAndInstagram'
      }),

      apps() {
        return this.getFacebookAndInstagram(this.childId)
      },

      facebook() {
        return this.apps.find(app => app.app_name === 'Facebook')
      },

      instagram() {
        return this.apps.find(app => app.app_name === 'Instagram')
      },

      action() {
        if (_.isEqual(this.facebook.app_action, this.instagram.app_action)) {
          return this.instagram.app_action
        }

        return 'block'
      },

      supportsProtection() {
        return this.apps.every(app => app.supports_protection)
      }
    },

    methods: {
      ...mapActions('children', {
        updateProtectedSocialMedia: 'updateProtectedSocialMedia'
      }),

      async changeAction(action) {
        await this.updateProtectedSocialMedia({
          user_id: this.childId,
          app_name: this.facebook.app_name,
          app_action: action
        })

        await this.updateProtectedSocialMedia({
          user_id: this.childId,
          app_name: this.instagram.app_name,
          app_action: action
        })
      }
    },

    watch: {
      action() {
        this.state = this.action
      }
    }
  }
</script>